import { type ReactNode } from 'react'

import { Badge } from '@gto/ui/badge'
import { Typography } from '@gto/ui/typography'

type DotStatusProps = { color: 'success' | 'secondary'; label: ReactNode }

export const DotStatus = ({ color, label }: DotStatusProps) => (
  <span className="inline-flex items-center gap-2">
    <Badge
      color={color}
      variant="dot"
    />
    <Typography variant="body2">{label}</Typography>
  </span>
)
